import { useMemo } from "react";

import { useFeatureToShow } from "../../FeatureSelector/hooks/useFeatureToShow";
import { useFeatureFromGeometryEditor } from "../../../components/GeometryEditor/useFeatureFromGeometryEditor";

import { FeatureCardMode } from "../types";
import { FeatureDcExtended } from "../../../ducks/selectFeatures/types";

type UseFeatureCardModule = {
  feature: FeatureDcExtended | null;
  mode?: FeatureCardMode;
  isEdit?: boolean;
  loading?: boolean;
};

export const useFeatureCardModule = (): UseFeatureCardModule => {
  const { feature: selectedFeature, loading } = useFeatureToShow();
  const editFeature = useFeatureFromGeometryEditor();

  const feature = useMemo(
    () =>
      selectedFeature === undefined && editFeature === undefined ? null : mergeFeatures(selectedFeature, editFeature),
    [selectedFeature, editFeature],
  );

  return {
    feature,
    mode: selectedFeature ? FeatureCardMode.Edit : FeatureCardMode.Create,
    isEdit: !!editFeature,
    loading,
  };
};

function mergeFeatures(selectedFeature: FeatureDcExtended, geometryFeature: FeatureDcExtended): FeatureDcExtended {
  if (selectedFeature && geometryFeature) {
    return {
      ...selectedFeature,
      geometry: geometryFeature.geometry,
    };
  }

  if (selectedFeature) {
    return selectedFeature;
  }

  return geometryFeature;
}
